import _export from '../internals/export.js';
import anObject$1 from '../internals/an-object.js';
import objectGetPrototypeOf$1 from '../internals/object-get-prototype-of.js';
import correctPrototypeGetter from '../internals/correct-prototype-getter.js';

var $ = _export;
var anObject = anObject$1;
var objectGetPrototypeOf = objectGetPrototypeOf$1;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter; // `Reflect.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-reflect.getprototypeof

$({
  target: 'Reflect',
  stat: true,
  sham: !CORRECT_PROTOTYPE_GETTER
}, {
  getPrototypeOf: function getPrototypeOf(target) {
    return objectGetPrototypeOf(anObject(target));
  }
});
